// Set up inline video controls for each video wrapper.
document.querySelectorAll("[data-video]").forEach((wrapper) => {
  const video = wrapper.querySelector(".sp-video__el");
  const control = wrapper.querySelector(".sp-video__control");
  if (!video || !control) return;

  // Keep the control label and aria text in sync with playback state.
  const updateLabel = () => {
    control.textContent = video.paused ? "Play" : "Pause";
    control.setAttribute("aria-label", control.textContent);
  };

  // Toggle playback from the overlay control.
  control.addEventListener("click", () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  // Refresh the label when playback changes.
  video.addEventListener("play", updateLabel);
  video.addEventListener("pause", updateLabel);

  updateLabel();
});
